
import * as Yup from 'yup';
import { parsePhoneNumberFromString as parsePhoneNumber } from 'libphonenumber-js';


export const createStep1Schema = (t, selectedCountry) =>
  Yup.object({
    fullName: Yup.string()
      .trim()
      .required(t('validation.required')),

    birthDate: Yup.string()
      .required(t('validation.required')),

    gender: Yup.string()
      .oneOf(['male', 'female'])
      .required(t('validation.required')),

    city: Yup.mixed().test(
      'city-required',
      t('validation.required'),
      (value) => {
        if (!value) return false;
        return typeof value === 'string'
          ? value.trim().length > 0
          : !!value.value;
      }
    ),

    email: Yup.string()
      .email(t('validation.invalidEmail'))
      .required(t('validation.emailRequired')),

    phone: Yup.string()
      .required(t('validation.required'))
      .test(
        'phone-validation',
        t('validation.invalidPhoneNumber'),
        function (value) {
          if (!value || value.trim() === '') return false;

          try {
            const digits = String(value).replace(/\D/g, '');
            const phoneToValidate = digits.startsWith('966')
              ? `+${digits}`
              : `+966${digits}`;

            const phoneNumber = parsePhoneNumber(phoneToValidate);

            if (!phoneNumber || !phoneNumber.isValid()) {
              return this.createError({
                message: t('validation.invalidPhoneFormat'),
              });
            }

            const touched = this?.options?.context?.touched?.phone;
            if (touched) {
              const phoneCountry = phoneNumber.country?.toLowerCase();
              const currentCountry = selectedCountry.toLowerCase();

              if (phoneCountry !== currentCountry) {
                return this.createError({
                  message: t('validation.phoneCountryMismatch'),
                });
              }
            }

            return true;
          } catch (error) {
            return this.createError({
              message: t('validation.invalidPhoneFormat'),
            });
          }
        }
      ),
  });

export const validateStep1Values = async (
  values,
  t,
  selectedCountry,
  touched = {}
) => {
  const schema = createStep1Schema(t, selectedCountry);

  try {
    await schema.validate(values, {
      abortEarly: false,
      context: { touched },
    });
    return {};
  } catch (err) {
    const errors = {};

    if (err.inner && Array.isArray(err.inner)) {
      err.inner.forEach((e) => {
        if (e.path && !errors[e.path]) {
          errors[e.path] = e.message;
        }
      });
    } else if (err.path) {
      errors[err.path] = err.message;
    }

    return errors;
  }
};